/* eslint-disable import/prefer-default-export */

export const MIN_PASSWORD_LENGTH = 6;
